import {ProductDetailMinRes} from './product.contract';
import {Type} from 'class-transformer';
import {OrderAmountUnit} from '../../../enums/OrderAmountUnit';
import {FileUploadRes} from '@yasc/yasc-material-components';
import moment, {Moment} from "moment";
import {BankAccountRes} from './bank.contract';
import {CompanyDetailsMinRes} from './company.contract';
import {UserDetailsMinRes} from './user.contract';

export class InvoiceDetailRes {
    id!: number
    invoiceNumber!: string;
    product?: ProductDetailMinRes
    company!: CompanyDetailsMinRes
    companyContact!: UserDetailsMinRes
    private _paidOn?: any;
    private _paymentTarget!: any;
    private _sentDate?: any;
    totalBrutto!: number;
    totalMwst!: number;
    totalNetto!: number;

    private _created: any;
    attachment!: FileUploadRes;
    bankAccount?: BankAccountRes;

    @Type(() => PositionDetailRes)
    positions: PositionDetailRes[] = []
    projectId?: number;


    get created(): any {
        return this._created;
    }

    set created(value: any) {
        this._created = moment(value);
    }

    get paidOn(): any {
        return this._paidOn;
    }

    set paidOn(value: any) {
        this._paidOn = value != undefined ? moment(value) : undefined;
    }

    get paymentTarget(): any {
        return this._paymentTarget;
    }

    set paymentTarget(value: any) {
        this._paymentTarget = moment(value);
    }

    get sentDate(): any {
        return this._sentDate;
    }

    set sentDate(value: any) {
        this._sentDate = value != undefined ? moment(value) : undefined;
    }

}

export class PositionDetailRes {
    id!: number
    description!: string
    amount!: number
    price!: number
    unit!: OrderAmountUnit
}

export class InvoiceUpdateReq {
    paidOn?: any;
    positions?: PositionCreateReq[];
}

export class InvoiceCreateReq {
    invoiceNumber!: string;
    buyerContactId!: number;
    productId?: string
    projectId?: number
    companyId!: number
    positions: PositionCreateReq[] = [];
    paymentTarget: Date = new Date().addDays(30);

    static FromDetails(model: Partial<InvoiceDetailRes>): InvoiceCreateReq {
        let dto = new InvoiceCreateReq();
        if (model.invoiceNumber) {
            model.invoiceNumber = dto.invoiceNumber;
        }
        if (model.paymentTarget) {
            dto.paymentTarget = model.paymentTarget;
        }
        if (model.invoiceNumber)
            dto.invoiceNumber = model.invoiceNumber;
        if (model.product)
            dto.productId = model.product.id
        if (model.projectId)
            dto.projectId = model.projectId;
        if (model.company) {
            dto.companyId = model.company!.id;
        }
        if (model.positions) {
            dto.positions = model.positions.map(e => PositionCreateReq.FromDetails(e));
        }

        return dto;
    }
}

export class PositionCreateReq {
    id?: number
    price!: number
    amount!: number
    orderAmountUnit: OrderAmountUnit = OrderAmountUnit.generalPieces;
    description!: string

    static FromDetails(e: Partial<PositionDetailRes>): PositionCreateReq {
        let dto = new PositionCreateReq();
        if (e.price)
            dto.price = e.price;
        if (e.amount)
            dto.amount = e.amount;
        if (e.unit)
            dto.orderAmountUnit = e.unit;
        if (e.description)
            dto.description = e.description;

        return dto;
    }
}

export interface PayInvoiceReq {
    invoiceId: number
    paidOn: string
}

export class InvoiceSendReq {
    receivers: string[] = []
}